import { enqueueSnackbar, SnackbarOrigin } from "notistack";
import i18n from "../i18n-config";
import { capitalizeFirstLetter } from "./strings";

export interface AnchorProps {
  horizontal: "center" | "right" | "left";
  vertical: "top" | "bottom";
}
export interface NotifyProps {
  message: string;
  severity?: "default" | "error" | "success" | "warning" | "info";
  vertical?: SnackbarOrigin["vertical"];
  horizontal?: SnackbarOrigin["horizontal"];
}

export default function notifyMessage({
  message = "",
  severity = "success",
  vertical = "top",
  horizontal = "center",
}: NotifyProps) {
  enqueueSnackbar(capitalizeFirstLetter(message), {
    variant: severity,
    autoHideDuration: 2000,
    anchorOrigin: { horizontal: horizontal, vertical: vertical },
  });
}

export const notifyPermission = () =>
  notifyMessage({
    message: i18n.t("can_not_perform_action"),
    severity: "warning",
  });
